"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Collection extends Array {
    constructor() {
        super();
        this.parent = null;
    }
    setCollectionReference(collectionReference) {
        this.collectionReference = collectionReference;
        this.id = collectionReference.id;
        this.path = collectionReference.path;
        this.parent = collectionReference.parent;
    }
    doc(id, type) {
        const ref = this.collectionReference.doc(id);
        return type.init(ref);
    }
}
exports.Collection = Collection;
//# sourceMappingURL=Collection.js.map